// firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCXGy1TAF6dtTh5geA-DVnha8Y2NscU7ng",
  authDomain: "signup-project-9285c.firebaseapp.com",
  projectId: "signup-project-9285c",
  storageBucket: "signup-project-9285c.appspot.com",
  messagingSenderId: "1096268722287",
  appId: "1:1096268722287:web:xxxxxx"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);
